module.exports = __webpack_public_path__ + "img/screen3.a78c7b23.png";